import { Component, OnInit, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {ModalCharteDeontologiqueComponent} from '../modal-charte-deontologique/modal-charte-deontologique.component';
import {AuthentificationService} from '../../../core/services/authentification.service';
import {HydraService} from '../../../core/services/hydra.service';
import {ToolsService} from '../../services/tools/tools.service';
import {UtilisateurDeclarationInteret} from '../../../class/api/UtilisateurDeclarationInteret';
import {LocalStorage} from 'ngx-webstorage';

import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-declaration-publique',
    templateUrl: './modal-declaration-publique.component.html',
    styleUrls: ['./modal-declaration-publique.component.scss'],
    imports: [TranslateModule, MatDialogContent]
})
export class ModalDeclarationPubliqueComponent implements OnInit {
    private hydraService = inject(HydraService);
    dialogRef = inject<MatDialogRef<ModalCharteDeontologiqueComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);
    auth = inject(AuthentificationService);
    private toolService = inject(ToolsService);

    @LocalStorage() public dateShort; // FR de base

    declaration = null;
    public declarationInteret: Object = {};

    constructor() {}

    ngOnInit() {
        if (this.data != null && this.data.declarationInteret != null) {
            this.getDeclaration();
        }
    }

    public getDeclaration() {
        this.hydraService
            .getById(this.data.declarationInteret)
            .subscribe((res: UtilisateurDeclarationInteret) => {
                res.tab1lines.map(item => {
                    item.dateLine = this.toolService.convertDateForFront(
                        item.dateLine
                    );
                });
                res.tab2lines.map(item => {
                    item.dateLine = this.toolService.convertDateForFront(
                        item.dateLine
                    );
                });
                this.declarationInteret = res;
            });
    }
}
